import { Review } from '@/types/review';

import { BaeminCopyInfoContent } from './CopyInfoContent';

/** 배민 블라인드 신청 내역 (pending 클릭 시) = CopyInfo와 동일 */
export const BaeminInfoContent = ({
  isOpen,
  review,
  onClose,
}: {
  isOpen: boolean;
  review: Review;
  onClose: () => void;
}) => {
  return (
    <BaeminCopyInfoContent
      isOpen={isOpen}
      review={review}
      onClose={onClose}
      title="리뷰 블라인드 신청 내역"
      showRequestedAt
    />
  );
};
